/* eslint-disable no-unused-vars */
/* eslint-disable multiline-comment-style */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkStringPermission } from 'helpers/filteredPermissions';

const ProtectedRoute = ({ page, component: Component }) => {
  const conditions = [
    {
      key: 'Inventory',
      permission: 'can view inventory module',
    },
    {
      key: 'Item Request',
      permission: 'can view item request module',
    },
    {
      key: 'Transaction',
      permission: 'can view transactions module',
    },
    {
      key: 'Approver',
      permission: 'can view approver module',
    },
    {
      key: 'Reports',
      permission: 'can view reports module',
    },
    {
      key: 'Inventory Staff',
      permission: 'can view inventory staff module',
    },
    {
      key: 'Audit Trail',
      permission: 'can view audit module',
    },
    {
      key: 'Users',
      permission: 'can view user module',
    },
    {
      key: 'ACL',
      permission: 'can view acl module',
    },
  ];

  const pages = conditions.filter((data) => data.key === page);

  if (pages.length > 0) {
    const result = checkStringPermission(pages[0]?.permission);

    if (result) {
      return <Component />;
    }

    return <Navigate to='/' />;
  }
};

export default ProtectedRoute;
